import PropTypes from 'prop-types';
// @mui
import { AppBar, Autocomplete, Box, Button, Stack, TextField, Toolbar, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
// utils
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
import { debounce } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import QRCodeDeviceModal from 'src/components/modal/QRCodeDeviceModal';
import { eventList, glb_sv, sendRequest, serviceList } from 'src/utils';
import crypt from 'src/utils/service/crypt';
import AccountPopover from './AccountPopover';
import Category from './Category';
import FullScreenButton from './FullScreenButton';
import LanguagePopover from './LanguagePopover';
import NotificationsPopoverV2 from './NotificationsPopoverV2';

// ----------------------------------------------------------------------

const NAV_WIDTH = 80;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
    ...bgBlur({ color: theme.palette.background.default }),
    boxShadow: 'none',
    [theme.breakpoints.up('xl')]: {
        // width: `calc(100% - ${NAV_WIDTH + 1}px)`,
        width: `100%`,
    },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    display: 'flex',
    // border: '1px solid #999',
    justifyContent: 'space-between',
    minHeight: HEADER_MOBILE,
    [theme.breakpoints.up('lg')]: {
        minHeight: HEADER_DESKTOP,
        padding: theme.spacing(0, 5),
    },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
    onOpenNav: PropTypes.func,
};

export default function Header({ countDisconect }) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [menuRender, setMenurender] = useState([]);

    const [search, setSearch] = useState('');
    const getRef = useRef(false);
    const [getFlags, setGetFlags] = useState(false);
    const [dataSearch, setDataSearch] = useState({});
    const [tableData, setTableData] = useState([]);
    const [getFlagsDevice, setGetFlagsDevice] = useState(false);
    const [visibleQR, setVisibleQR] = useState(false);
    const cabinetData = useRef({});
    const searchValueDeboun = useRef('');
    const throttled = useRef(debounce(() => getData(searchValueDeboun.current), 1000));
    const throttledDevices = useRef(debounce((value) => getDataDevices(value), 500));
    const isMobile = useMediaQuery('(max-width:600px)');

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        const menu = sessionStorage.getItem('menu');
        cabinetData.current = glb_sv.getLocalStorageCabinet('cabinet') || JSON.parse(sessionStorage.getItem('cabinet'));
        if (!userData || !menu) {
            navigate('/login');
        }
        if (userData && menu) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                glb_sv.userInfo = data;
                const dataMenu = JSON.parse(crypt.deCode(menu));
                glb_sv.menu = dataMenu;
                glb_sv.sessionInfo.comp_id = data.o_3;
                glb_sv.sessionInfo.branch_id = data.o_4;
                glb_sv.sessionInfo.user_id = data.id;
                // const sliceMenu = dataMenu.filter((item) => item?.permiss_screen?.search === '1');
                // setMenurender([sliceMenu[0], sliceMenu[1], sliceMenu[2]]);
                const sliceMenu = dataMenu[0]?.filter((item) => {
                    return (
                        (item.screens_key === 'nhap_xuat_tb' && item.search_permission === '1') ||
                        (item.screens_key === 'lay_muon_tb' && item.search_permission === '1') ||
                        (glb_sv.userInfo?.group_user === '1'
                            ? item.screens_key === 'xuat_bao_cao' && item.search_permission === '1'
                            : item.screens_key === 'thong_ke' && item.search_permission === '1') ||
                        (item.screens_key === 'print_qr' && item.search_permission === '1')
                    );
                });
                setMenurender(sliceMenu);
                if (!isMobile) {
                    setTimeout(() => {
                        getDataDevices();
                    }, 500);
                }
            } catch (error) {}
        }
    }, []);

    useEffect(() => {
        glb_sv.commonEvent.subscribe((msg) => {
            if (msg.type === eventList.CHANGE_CABINET) {
                cabinetData.current =
                    glb_sv.getLocalStorageCabinet('cabinet') || JSON.parse(sessionStorage.getItem('cabinet'));
            }
        });
    }, []);

    const getDataDevices = (value = '') => {
        if (getFlagsDevice) {
            return;
        }
        setGetFlagsDevice(true);
        const InVal = [999999999, value.trim()];
        sendRequest(serviceList.getAllDeviceSpByNm, InVal, getDataResultDevices, true, timeOutFunctDevices, 40000);
    };

    const getDataResultDevices = (reqInfoMap, message) => {
        setGetFlagsDevice(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
        }
    };

    const timeOutFunctDevices = (reqInfo) => {
        setGetFlagsDevice(false);
        toast.error(t('error.time_out'));
    };

    const getData = (value = searchValueDeboun.current) => {
        if (getRef.current || !searchValueDeboun.current || !cabinetData.current?.cabinet_cd) {
            return;
        }
        getRef.current = true;
        const InVal = [searchValueDeboun.current.trim(), cabinetData.current?.cabinet_cd || ''];
        sendRequest(serviceList.getByDeviceCode, InVal, getDataResult, true, timeOutFunct, 40000);
    };

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log('Search', message.proc_data.rows[0]);
            if (message.proc_data.rows[0].o_1.length > 1) {
                setTableData(message.proc_data.rows[0].o_1);
            }
            if (message.proc_data.rows[0].o_1.length !== 0 && message.proc_data.rows[0].o_2) {
                setVisibleQR(true);
                setDataSearch(message.proc_data.rows[0]);
                setSearch('');
            }
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
    };

    const searchValue = (value) => {
        searchValueDeboun.current = value;
        setSearch(searchValueDeboun.current);
        throttled.current();
    };
    const handleInputChange = (event, newInputValue) => {
        searchValueDeboun.current = newInputValue;
        setSearch(searchValueDeboun.current);
        throttledDevices.current(newInputValue);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            console.log('User pressed Enter:', event.target.value);
            // Thực hiện hành động khi nhấn Enter
            searchValue(event.target.value);
        }
    };
    return (
        <StyledRoot>
            <StyledToolbar>
                <QRCodeDeviceModal
                    visible={visibleQR}
                    setVisible={setVisibleQR}
                    dataSearch={dataSearch}
                    setDataSearch={setDataSearch}
                />
                <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block', xl: 'block' } }}>
                    <Button
                        startIcon={<Iconify icon={'ic:round-home'} width={25} height={25} />}
                        sx={{ color: '#057a6b' }}
                        to="/home"
                        LinkComponent={RouterLink}
                    >
                        {t('home')}
                    </Button>
                    {menuRender.length > 0 &&
                        menuRender.map((item, index) => (
                            <Button
                                key={index}
                                sx={{ color: '#057a6b' }}
                                to={item?.navigate ? item.navigate + item.id : '/'}
                                LinkComponent={RouterLink}
                            >
                                {t(item?.screens_key)}
                            </Button>
                        ))}
                </Box>
                <Box sx={{ display: { xs: 'block', sm: 'block', md: 'none', xl: 'none' } }}>
                    <Button
                        startIcon={<Iconify icon={'ic:round-home'} width={25} height={25} />}
                        sx={{ color: '#057a6b' }}
                        to="/"
                        LinkComponent={RouterLink}
                    >
                        {t('home')}
                    </Button>
                </Box>
                <Box sx={{ flexGrow: 1 }} />

                <Stack
                    direction="row"
                    alignItems="center"
                    spacing={{
                        xs: 1,
                        sm: 1.5,
                    }}
                >
                    {!isMobile && (
                        <Autocomplete
                            id="free-solo-demo"
                            freeSolo
                            options={tableData.map((option) => option.device_cd)}
                            renderInput={(params) => (
                                <TextField
                                    onKeyDown={handleKeyDown}
                                    {...params}
                                    label={t('search_QR_device')}
                                    variant="standard"
                                    autoFocus
                                />
                            )}
                            size="small"
                            sx={{ width: 250 }}
                            value={search}
                            onInputChange={handleInputChange}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    searchValue(newValue);
                                }
                            }}
                        />
                    )}
                    <FullScreenButton />
                    <LanguagePopover />
                    {/* <NotificationsPopover countDisconect={countDisconect} /> */}
                    <NotificationsPopoverV2 countDisconect={countDisconect} />
                    <Category />
                    <AccountPopover />
                </Stack>
            </StyledToolbar>
        </StyledRoot>
    );
}
